import React, { useState, useEffect } from 'react';
import {
  Box,
  Heading,
  VStack,
  useToast,
  Flex,
  Tr,
  Table,
  Th,
  Td,
  Thead,
  Tbody,
  useColorMode,
} from '@chakra-ui/react';
import Navigation from '../components/Navigation';
import axios from '../utils/axiosConfig';

const AdminListCollectionsPage = () => {
  const { colorMode } = useColorMode();
  const toast = useToast();
  const [isAdmin, setIsAdmin] = useState(null);
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const response = await axios.get('/api/protected/checkIsAdmin');
        setIsAdmin(response.data.isAdmin);

      } catch (error) {
        console.error('Error checking session:', error);
        setIsAdmin(false);
      }
    };

    checkAuthentication();
    listCollections();
  }, []);

  const formatDateTime = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const listCollections = async () => {
    try {
      const response = await axios.get('/api/admin/collections');
      if (response.data?.success && response.data?.data?.collections) {
        setCollections(response.data.data.collections);
      } else {
        toast({ 
          title: 'Failed to retrieve collections', 
          status: 'error',
          description: 'Invalid response format'
        });
      }
    } catch (error) {
      console.error('Error fetching collections:', error);
      toast({ 
        title: 'Failed to retrieve collections', 
        status: 'error',
        description: error.response?.data?.message || 'An error occurred'
      });
    }
  };

  return !isAdmin ? (<></>) : (
    <Flex>
      <Navigation />
      <Box p={8} flex="1">
        <Heading size="lg" mb={6} color={colorMode === 'light' ? 'gray.800' : 'white'}>All Users</Heading>
        <VStack spacing={4} align="stretch">
          <Table variant="simple" size="lg">
            <Thead position="sticky" top={0} bg={colorMode === 'light' ? 'gray.100' : 'gray.700'} zIndex={1}>
              <Tr>
                <Th color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Name</Th>
                <Th color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Email</Th>
                <Th color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Role</Th>
                <Th color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Created On</Th>
                <Th color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Last Updated On</Th>
              </Tr>
            </Thead>
            <Tbody>
              {collections.map((u) => (
                <Tr key={u._id}>
                  <Td color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>{u.name}</Td>
                  <Td color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>{u.email}</Td>
                  <Td color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>{u.role}</Td>
                  <Td color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>{formatDateTime(u.createdAt)}</Td>
                  <Td color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>{formatDateTime(u.updatedAt)}</Td>
              
                </Tr>
              ))}
            </Tbody>
          </Table>
        </VStack>
      </Box>
    </Flex>
  );
};

export default AdminListCollectionsPage; 